import { Skeleton } from '@bbl-digital/snorre-v2'

type Props = {
  pageSize?: number
}

const Loading = ({ pageSize }: Props) => {
  return (
    <div>
      {Array.from({ length: pageSize || 5 }).map((_, index) => (
        <div
          key={index}
          className="flex justify-between items-center border rounded-md border-border-subtle mb-1 p-1"
        >
          <div className="flex gap-1 items-center min-w-0 h-6">
            <Skeleton className="min-w-[20px] min-h-[20px] w-[20px] h-[20px] rounded" />
            <Skeleton className="h-24 max-w-[200px] w-[200px]" />
          </div>
          <Skeleton className="h-24 w-[90px] rounded-md" />
        </div>
      ))}
    </div>
  )
}

export default Loading
